export enum BroadcasterEvent
{
  EVENT_ON_CONTACT_SELECTED = 'EVENT_ON_CONTACT_SELECTED',
  EVENT_JWT = 'EVENT_JWT',
  EVENT_DEF_MSG = 'EVENT_DEF_MSG',
  EVENT_SHOW_CHAT_ERROR = 'EVENT_SHOW_CHAT_ERROR',
  EVENT_ON_MESSAGE_SENT_OR_RETRIEVED = 'EVENT_ON_MESSAGE_SENT_OR_RETRIEVED',
  EVENT_DESPATCH_GROUP = 'EVENT_DESPATCH_GROUP'
}
